import * as Sentry from "@sentry/react";

/**
 * Report an error to Sentry with optional context.
 * @param {Error|string} error
 * @param {object} [context] — extra key/value pairs attached to the event
 */
export function captureError(error, context) {
	if (context) {
		Sentry.withScope((scope) => {
			scope.setExtras(context);
			if (typeof error === "string") {
				Sentry.captureMessage(error, "error");
			} else {
				Sentry.captureException(error);
			}
		});
	} else if (typeof error === "string") {
		Sentry.captureMessage(error, "error");
	} else {
		Sentry.captureException(error);
	}
}

/**
 * Report a warning-level message to Sentry.
 * @param {string} message
 * @param {object} [context]
 */
export function captureWarning(message, context) {
	if (context) {
		Sentry.withScope((scope) => {
			scope.setExtras(context);
			Sentry.captureMessage(message, "warning");
		});
	} else {
		Sentry.captureMessage(message, "warning");
	}
}
